import React from 'react';
import {
	ResponsiveContainer, Tooltip, CartesianGrid, XAxis, YAxis,
	BarChart, Bar
} from 'recharts';
import BlockUi from 'react-block-ui';
import { COLORS } from '../utils';
import { RotatedAxisTick } from '../../../common/components/charts';
import { withTranslation } from 'react-i18next';

const LessonPaymentsByGrade = ({ loading, data, height = 300, t }) => {
	return <BlockUi blocking={loading}>
		<ResponsiveContainer height={height}>
			<BarChart data={data}>
				<XAxis tick={<RotatedAxisTick formatter={index => { const item = data[index]; return item && item.shortName; }} />} height={60} />	{/* use the index of the item as dataKey but replace with Grade.ShortName when displaying as tick on X axis */}
				<YAxis yAxisId='left' orientation='left' stroke={COLORS[0]} axisLine={false} tickLine={false} />
				<YAxis yAxisId='right' orientation='right' stroke={COLORS[1]} axisLine={false} tickLine={false} />
				<CartesianGrid vertical={false} />
				<Tooltip labelFormatter={index => { const item = data[index]; return item && item.name; }} />		{/* use the index of the item as dataKey but replace with Grade.Name when displaying as label in the Tooltip */}
				<Bar yAxisId='left' name={t('SalesDashboard_Revenue')} dataKey='amount' fill={COLORS[0]} />
				<Bar yAxisId='right' name={t('SalesDashboard_NumberOfSales')} dataKey='count' fill={COLORS[1]} />
			</BarChart>
		</ResponsiveContainer>
	</BlockUi>;
};

export default withTranslation()(LessonPaymentsByGrade);